export const SET_CART = "SET_CART";
export const SET_ITEMS = "SET_ITEMS";
export const RESET_CART = "RESET_CART";

export const setCart = (payload) => ({payload, type: SET_CART});
export const setItems = (payload) => ({payload, type: SET_ITEMS});
export const resetCart = () => ({type: RESET_CART});
